import { useNavigate } from "react-router-dom";


const Desktop30 = () => {

    return (
        <div className="bg-[#f9f9f9] w-full overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-b from-[#06010A] to-[#260345] text-white flex flex-col items-center justify-center px-8 md:px-16 lg:px-24 py-20 overflow-hidden min-h-screen">
                {/* Decorative Ellipses */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#7B3FE4]/40 rounded-full blur-3xl top-[-100px] left-[-100px]" />
                    <div className="absolute w-[350px] h-[350px] bg-[#E6C1FF]/30 rounded-full blur-3xl bottom-[-150px] right-[-100px]" />
                </div>

                {/* Centered Content Section */}
                <div className="relative flex items-center justify-center w-full px-6">
                    <div className="relative z-10 max-w-2xl text-center">
                        <h3 className="text-lg text-[#ffffffbf] mb-3">Contact Us</h3>
                        <h1 className="text-4xl md:text-5xl font-semibold leading-tight mb-6 text-white">
                            Discover the right job as easily as finding your next trip
                        </h1>
                        <p className="text-gray-200 mb-8 text-base md:text-lg">
                            Have questions about your resume or our services? We're here to help you nail that application.
                            Get in touch with us for quick answers, details on our tailoring process,
                            and friendly 24/7 support. Reach out now and take the first step toward your next role!
                        </p>
                        <div className="flex items-center justify-center gap-4 mt-6">
                            {/* <button onClick={() => navigate('/auth')} className="inline-flex items-center gap-2 bg-[#FFD600] text-[#0E0E0E] font-semibold px-6 py-3 rounded-full hover:brightness-95">
                                Get Started
                            </button> */}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Desktop30;
